import { useState, useContext, useEffect } from "react";
import { confirmDialog } from "primereact/confirmdialog";
import { RadioButton } from "primereact/radiobutton";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button, Calendar, InputText, InputTextarea, classNames } from "primereact";

// ------------------ COMPONENTES DE BASE--------------------------
import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import Card from "../../../../../Base/Components/Card/Card";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";

import { EliminarPaseDetalle, ObtenerSiguienteNoPase } from "../../../../../API/Logistica/PasesSalidaRequest";
import MotoristasCRUD from "../../../Global/Motoristas/MotoristasCRUD";
import VehiculosCRUD from "../../../Global/Vehiculos/VehiculosCRUD";
import TypesCrudModal from "../../../../../Base/Screens/Global/Types/TypesCrud/TypesCrudModal";

const EncabezadoPase = ({
  values,
  setValues,
  handleInputChange,
  habilitar,
  setHabilitar,
  areas,
  userSolicitar,
  motivos,
  vehiculos,
  motoristas,
  proveedor,
  toast,
  agregarNuevaFila,
  detalles,
  setDetalles,
  guardarPase,
  getInfo2,
  selected,
  setSelected,
  getInfo,
  habilitarRetorno,
  setHabilitarRetorno,
  informacionDropdown
}) => {
  const { userAuth } = useContext(AuthContext);
  const [NoPase, setNoPase] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dialogMotorista, setDialogMotorista] = useState(false);
  const [dialogVehiculo, setDialogVehiculo] = useState(false);
  const [dialogMotivo, setDialogMotivo] = useState(false);

  const verificarCampos = () => {
    let err = false;

    if(!values?.IdUserSolicita && !values?.UserNameSolicita){
        err = true;
        toastShow(toast, "error", "Error", "Solicita es requerido.");
        return
    }
    if(!values?.IdArea && !values?.Area){
        err = true;
        toastShow(toast, "error", "Error", "Area es requerida.");
        return
    }
    if(!values?.IdVehiculo && !values?.VehiculoCompleto){
        err = true;
        toastShow(toast, "error", "Error", "Vehículo es requerido.");
        return
    }
    if(!values?.IdMotorista && !values?.NombreCompletoMotorista){
        err = true;
        toastShow(toast, "error", "Error", "Motorista es requerido.");
        return
    }
    if(!values?.IdMotivo && !values?.Motivo){
        err = true;
        toastShow(toast, "error", "Error", "Motivo es requerido.");
        return
    }
    if(!values?.CustomerName){
        err = true;
        toastShow(toast, "error", "Error", "El Destino es requerido.");
        return
    }
    if(values?.Retorna){
        if(!values?.FechaRetornoTent){
            err = true;
            toastShow(toast, "error", "Error", "Fecha de retorno es requerida.");
            return
        }
    }
    if(!values?.selectedOption){
        err = true;
        toastShow(toast, "error", "Error", "Seleccione el tipo de salida.");
        return
    }

    return !err;
  };

  const getInfoNew = async () => {
    setLoading(true);
    const Npase = await ObtenerSiguienteNoPase();
    setNoPase(Npase);

    const d = {
      IdPase: -100,
      IdEstado: 58,
      StatusName: "Solicitado",
      FechaCreacion: new Date(),
      NoPaseSalida: Npase[0].NumPaseSalida,
      Comentario: "",
      Direccion: '',
    };
    setValues(d);
    setHabilitar(true)
    setDetalles([])
    setLoading(false);
  };

  const nuevoIngreso = () => {
    confirmDialog({
      message: "¿Está seguro que desea crear un nuevo pase de salida?",
      header: "Nuevo Pase",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => {
        getInfoNew();
      },
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  const habilitarComponentes = () => {
    if(values?.IdEstado === 61){
      toastShow(toast,"warn", "Advertencia", "No se puede editar un pase de salida en estado 'Completado'.");
    }else{
      if(values?.IdEstado === 62){
        setHabilitarRetorno(false)
      }else{
        setHabilitar(true);
      }
    }
  };

  const EliminarDetalle = () => {
    if (selected.length <= 0) {
      toastShow(toast,"warn","Advertencia","Seleccione al menos un detalle.");
      return;
    }
    selected.forEach(async (select) => {
      if (select.IdPaseDet > 0) {
        if(select.IdEstadoEnc === 61 || select?.IdEstadoEnc === 62){
          toastShow( toast, "error", "Error al eliminar", select.IdEstado === 61 ? "El pase de salida ya esta completado" : 'El pase de salida está en "Pendiente Retorno" ' );
        }else{
          const respuesta = await EliminarPaseDetalle(select)
        }
      } else {
        let tempo2 = detalles.filter((i) => !selected.some((e) => e.IdPaseDet === i.IdPaseDet));
        setDetalles(tempo2);
      }
    });
    toastShow( toast, "success", "Eliminado", selected.length > 1 ? "Detalles de pases de salida eliminados correctamente" : 'Detalle de pase de salida eliminado correctamente' );
    getInfo2(values)
    getInfo()
    setSelected([]);
  };

  useEffect(() => {
    if(values?.CustomerName === null){
        setValues({
            ...values,
            Direccion: null
        })
    }else{
        setValues({
            ...values,
            Direccion: values?.CustomerName?.Address
        })
    }
  }, [values?.CustomerName]);
  
  return (
    <div className="form-demo px-3 mb-2 mt-2">
      <div className="d-flex flex-column justify-content-center">
        <Loader loading={loading} />
        <Card
          header={"Pase de Salida"}
          contenido={
            <div>
              <div className="d-flex flex-wrap align-items-start gap-3 mt-2">
                {/* No. Pase */}
                <span className="p-inputgroup " style={{ maxWidth: 200 }}>
                  <span className=" field p-float-label">
                    <InputText
                      id="NoPaseSalida"
                      name="NoPaseSalida"
                      value={values?.NoPaseSalida}
                      onChange={handleInputChange}
                      style={{ fontWeight: "bold" }}
                      onKeyDown={(e) =>
                        e.keyCode === 13 ? informacionDropdown(values) : null
                      }
                    />
                    <label htmlFor="NoPaseSalida">No. Pase</label>
                  </span>

                  <Button
                    icon="pi pi-search"
                    type="button"
                    onClick={() => informacionDropdown(values)}
                    tooltip="Buscar Pase"
                    tooltipOptions={{position: "top"}}
                  />
                </span>

                {/* Fecha */}
                <span className="p-float-label">
                  <Calendar
                    id="FechaCreacion"
                    name="FechaCreacion"
                    disabled
                    value={values?.FechaCreacion}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    showIcon
                    style={{ height: 45, width: 180 }}
                  />
                  <label htmlFor="FechaCreacion">Fecha Creación</label>
                </span>

                {/* Estado */}
                <span className=" p-float-label">
                  <InputText
                    id="estado"
                    disabled
                    name="estado"
                    value={values?.StatusName}
                    style={{ width: "100%", padding: "6px 3px" }}
                  />
                  <label htmlFor="estado">Estado</label>
                </span>

                {/* Usuario */}
                <span className=" p-float-label">
                  <InputText
                    disabled
                    id="UserNameCreate"
                    name="UserNameCreate"
                    readOnly
                    value={values.UserNameCreate || userAuth?.UserName}
                    autoFocus
                    style={{ width: "100%", padding: "6px 3px" }}
                  />
                  <label htmlFor="UserCreate">Usuario Creación</label>
                </span>

                <AutoCompleteDropdown
                  enable={habilitar}
                  value={values.UserNameSolicita}
                  items={userSolicitar}
                  field={"UserName"}
                  name={"UserNameSolicita"}
                  handleInputChange={handleInputChange}
                  tabIndex={4}
                  label={"Solicita"}
                />

                <AutoCompleteDropdown
                  enable={habilitar}
                  value={values.Area}
                  items={areas}
                  field={"Area"}
                  name={"Area"}
                  handleInputChange={handleInputChange}
                  tabIndex={4}
                  label={"Area"}
                />

                <div style={{ width: 280 }}>
                  <AutoCompleteDropdown
                    enable={habilitar}
                    value={values.VehiculoCompleto}
                    items={vehiculos}
                    field={"VehiculoCompleto"}
                    name={"VehiculoCompleto"}
                    handleInputChange={handleInputChange}
                    tabIndex={4}
                    label={"Vehículo"}
                  />
                </div>

                <AutoCompleteDropdown
                  enable={habilitar}
                  value={values.NombreCompletoMotorista}
                  items={motoristas}
                  field={"NombreConcatenado"}
                  name={"NombreCompletoMotorista"}
                  handleInputChange={handleInputChange}
                  tabIndex={4}
                  label={"Motorista"}
                />

                <div style={{ width: 280 }}>
                  <AutoCompleteDropdown
                    enable={habilitar}
                    value={values.Motivo}
                    items={motivos}
                    field={"Type"}
                    name={"Motivo"}
                    handleInputChange={handleInputChange}
                    label={"Motivo"}
                  />
                </div>

                <div style={{ width: 280 }}>
                  <AutoCompleteDropdown
                    enable={habilitar}
                    value={values.CustomerName}
                    items={proveedor}
                    field={"CustomerName"}
                    name={"CustomerName"}
                    handleInputChange={handleInputChange}
                    label={"Destino"}
                  />
                </div>

                {/* Comentarios */}
                <span className=" p-float-label d-flex">
                  <InputTextarea
                    disabled
                    id="Direccion"
                    name="Direccion"
                    value={values?.Direccion}
                    onChange={handleInputChange}
                    cols={63}
                    style={{
                      width: "100%",
                      maxHeight: "3rem",
                      maxWidth: "72vh",
                      height: "3rem",
                    }}
                  />
                  <label id="label_comentario" htmlFor="Direccion">
                    Dirección
                  </label>
                </span>

                {/* Comentarios */}
                <span className=" p-float-label d-flex">
                  <InputTextarea
                    disabled={!habilitar}
                    id="Comentario"
                    name="Comentario"
                    value={values?.Comentario}
                    onChange={handleInputChange}
                    cols={65}
                    rows={2}
                    style={{
                      width: "100%",
                      maxHeight: "3rem",
                      maxWidth: "72vh",
                      height: "3rem",
                    }}
                  />
                  <label id="label_comentario" htmlFor="Comentario">
                    Comentario
                  </label>
                </span>
              </div>

              {/* --------------------------BOTONES-----------------------  */}
              <div className="d-flex flex-wrap gap-3 mb-2">
                <div className="groupEncabezado encabezado__contenido-Card d-flex gap-1 mt-5 flex-wrap justify-content-between">
                  <Button
                    icon="pi pi-plus"
                    disabled={!habilitar}
                    type="button"
                    tooltip="Agregar Items"
                    tooltipOptions={{position: "top"}}
                    onClick={(e) => {
                      if (verificarCampos()) {
                        agregarNuevaFila();
                      }
                    }}
                    tabIndex={7}
                  />
                  <Button
                    icon="pi pi-save"
                    disabled={!habilitar && habilitarRetorno}
                    tooltip="Guardar"
                    tooltipOptions={{position: "top"}}
                    onClick={(e) => {
                      guardarPase();
                    }}
                    style={{ marginLeft: 1 }}
                  />
                  <Button
                    icon="pi pi-pencil"
                    type="button"
                    onClick={habilitarComponentes}
                    tooltip="Editar"
                    tooltipOptions={{position: "top"}}
                    style={{ marginLeft: 1 }}
                  />
                  <Button
                    icon="pi pi-times"
                    type="button"
                    className="p-button-danger encabezado__herramienta-botones"
                    onClick={() => EliminarDetalle()}
                    tooltip="Eliminar"
                    disabled={!habilitar}
                    tooltipOptions={{position: "top"}}
                    style={{ marginLeft: 1 }}
                  />
                  <Button
                    icon="pi pi-book"
                    type="button"
                    onClick={nuevoIngreso}
                    tooltip="Nuevo"
                    tooltipOptions={{position: "top"}}
                    style={{ marginLeft: 1 }}
                  />
                  <Button
                    icon="pi pi-sync"
                    type="button"
                    onClick={() => getInfo2(values)}
                    tooltip="Cargar"
                    tooltipOptions={{position: "top"}}
                    style={{ marginLeft: 1 }}
                  />
                </div>

                <Card
                  titulo={"Tipo de Salida"}
                  contenido={
                    <div className="d-flex">
                      <div className="d-flex flex-wrap gap-3">
                        {/* RadioButton group */}
                        <span className="d-flex align-items-center">
                          <RadioButton
                            inputId="isActivo"
                            name="option"
                            value="IsActivo"
                            checked={values?.selectedOption === "IsActivo"}
                            onChange={(e) => {
                              if (detalles.length > 0) {
                                toastShow(
                                  toast,
                                  "error",
                                  "Error",
                                  "Ya existen detalles con otro tipo de salida"
                                );
                                return;
                              } else {
                                handleInputChange({
                                  target: {
                                    name: "selectedOption",
                                    value: e.value,
                                  },
                                });
                              }
                            }}
                          />
                          <label htmlFor="isActivo" className="mx-2">
                            Activo
                          </label>
                        </span>

                        <span className="d-flex align-items-center">
                          <RadioButton
                            inputId="isProducto"
                            name="option"
                            value="IsProducto"
                            checked={values?.selectedOption === "IsProducto"}
                            onChange={(e) => {
                              if (detalles.length > 0) {
                                toastShow(
                                  toast,
                                  "error",
                                  "Error",
                                  "Ya existen detalles con otro tipo de salida"
                                );
                                return;
                              } else {
                                handleInputChange({
                                  target: {
                                    name: "selectedOption",
                                    value: e.value,
                                  },
                                });
                              }
                            }}
                          />
                          <label htmlFor="isProducto" className="mx-2">
                            Producto
                          </label>
                        </span>

                        <span className="d-flex align-items-center">
                          <RadioButton
                            inputId="isIngreso"
                            name="option"
                            value="IsIngreso"
                            checked={values?.selectedOption === "IsIngreso"}
                            onChange={(e) => {
                              if (detalles.length > 0) {
                                toastShow(
                                  toast,
                                  "error",
                                  "Error",
                                  "Ya existen detalles con otro tipo de salida"
                                );
                                return;
                              } else {
                                handleInputChange({
                                  target: {
                                    name: "selectedOption",
                                    value: e.value,
                                  },
                                });
                              }
                            }}
                          />
                          <label htmlFor="isIngreso" className="mx-2">
                            Ingreso
                          </label>
                        </span>

                        <span className="d-flex align-items-center">
                          <RadioButton
                            inputId="otro"
                            name="option"
                            value="Otro"
                            checked={values?.selectedOption === "Otro"}
                            onChange={(e) => {
                              if (detalles.length > 0) {
                                toastShow(
                                  toast,
                                  "error",
                                  "Error",
                                  "Ya existen detalles con otro tipo de salida"
                                );
                                return;
                              } else {
                                handleInputChange({
                                  target: {
                                    name: "selectedOption",
                                    value: e.value,
                                  },
                                });
                              }
                            }}
                          />
                          <label htmlFor="otro" className="mx-2">
                            Otro
                          </label>
                        </span>
                      </div>
                    </div>
                  }
                />

                <Card
                  contenido={
                    <div className="d-flex">
                      <div className="d-flex flex-wrap gap-2">
                        <Button
                          icon="ri-steering-2-line"
                          tooltip="Agregar Motorista"
                          tooltipOptions={{ position: "top" }}
                          onClick={(e) => setDialogMotorista(true)}
                        />

                        <Button
                          icon="ri-car-line"
                          tooltip="Agregar Vehículo"
                          tooltipOptions={{ position: "top" }}
                          onClick={(e) => setDialogVehiculo(true)}
                        />

                        <Button
                          icon="ri-book-open-line"
                          tooltip="Agregar Motivo"
                          tooltipOptions={{ position: "top" }}
                          onClick={(e) => setDialogMotivo(true)}
                        />
                      </div>
                    </div>
                  }
                />
              </div>
            </div>
          }
        />
      </div>

      {dialogMotorista && (
        <MotoristasCRUD
          showDialog={dialogMotorista}
          selected={[]}
          setShowDialog={setDialogMotorista}
          getInfo={informacionDropdown}
          modo={"Crear"}
        />
      )}

      {dialogVehiculo && (
        <VehiculosCRUD
          showDialog={dialogVehiculo}
          selected={[]}
          setShowDialog={setDialogVehiculo}
          getInfo={informacionDropdown}
          modo={"Crear"}
        />
      )}

      {dialogMotivo && (
        <TypesCrudModal
          tiposDialog={dialogMotivo}
          tipo={[]}
          setTiposDialog={setDialogMotivo}
          getTypes={informacionDropdown}
          modo={"Crear"}
          motivo={true}
        />
      )}
    </div>
  );
};

export default EncabezadoPase;
